import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import promise from 'redux-promise'
import Home from './components/home'
import Category from './components/category'
import Product from './components/product'
import Faq from './components/faq'
import AboutUs from './components/aboutus'
import ContactUs from './components/contactus'
import PageOrderReview from './components/page_order_review'
import PageRegister from './components/page_register'
import PageLogin from './components/page_login'
import PageUserInfo from './components/page_user_info'
import PageConfirmAddress from './components/page_confirm_address'
import PagePayment from './components/page_payment'
import OrderHistory from './components/page_order_history'
import FinishOrder from './components/page_finished_order'
import RegisterSuccessfulPage from './components/page_register_successful'
import TestComponentPage from './components/test_component_credit_card_input'
import TestCarousel from './components/test_carousel'
import PrivacyPolicy from './components/page_privacy_policy'
import TermsOfService from './components/page_terms_of_service'
import BlogPage from './components/blogPage'
import Address from './components/component_address_new'
import reducers from './reducers'
import PasswordPage from './components/passwordPage'
import ForgetPasswordPage from './components/forgetPasswordPage'
import BusinessSolution from './components/business-solution/page_business_solution'

const createStoreWithMiddleware = applyMiddleware(promise)(createStore);
ReactDOM.render(
  <Provider store={createStoreWithMiddleware(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())}>
    <BrowserRouter>
      <div>
        <Switch>
          <Route path='/aboutus' component={AboutUs} />
          <Route path='/faq' component={Faq} />
          <Route path='/contactus' component={ContactUs} />
          <Route path='/product/:productid' component={Home} />
          <Route path='/search/:searchid' component={Home} />
          <Route path='/order_review' component={PageOrderReview} />
          <Route path='/register' component={PageRegister} />
          <Route path='/login' component={PageLogin} />
          <Route path='/user_info' component={PageUserInfo} />
          <Route path='/confirm_address' component={PageConfirmAddress} />
          <Route path='/payment' component={PagePayment} />
          <Route path='/orderhistory' component={OrderHistory} />
          <Route path='/finished_order' component={FinishOrder} />
          <Route path='/register_successful' component={RegisterSuccessfulPage} />
          <Route path='/privacy' component={PrivacyPolicy} />
          <Route path='/terms_of_service' component={TermsOfService} />
          <Route path='/blog/:blogID' component={BlogPage} />
          <Route path='/add_address' component={Address} />
          <Route path='/password' component={PasswordPage} />
          <Route path='/forget_password' component={ForgetPasswordPage} />
          <Route path='/business_solution' component={BusinessSolution} />
          {/* <Route path='/test_carousel' component={TestCarousel} /> */}
          {/* <Route path='/test_credit_card' component={TestComponentPage} /> */}
          <Route path='/' component={Home} />
        </Switch>
      </div>
    </BrowserRouter>
  </Provider>
  , document.querySelector('.containerr'));



// WEBPACK FOOTER //
// ./src/index.js